import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import Small from 'UIComponents/elements/Small';
import { Flow } from 'signup-constants/Flow';
import { Intent } from 'signup-constants/Intent';
import { getLegalLink } from '../legal/getLegalLink';
import { getIntegrationName } from '../utils/getIntegrationName';
import { isFlow } from '../utils/isFlow';
import { isIntent } from '../utils/isIntent';
import { CustomTermsAndConditions, StyledPrivacyBanner } from './CustomTermsAndConditions';
import { StyledUILink } from './TextInput.styles';
import { usePrivacyBanner } from './usePrivacyBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const PrivacyBanner = () => {
  const {
    privacyPolicyTextI18nLabel,
    shouldShowPrivacyBanner,
    handleClickTermsOfService,
    handleClickPrivacyPolicy
  } = usePrivacyBanner();
  if (!shouldShowPrivacyBanner) {
    return null;
  }
  const LegitimateInterest = /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: privacyPolicyTextI18nLabel,
    options: {
      termsOfServiceLink: /*#__PURE__*/_jsx(StyledUILink, {
        href: getLegalLink('terms-of-service'),
        onClick: handleClickTermsOfService,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "legal.termsOfServiceLink"
        })
      }, "gdprPolicy"),
      privacyPolicyLink: /*#__PURE__*/_jsx(StyledUILink, {
        external: true,
        href: getLegalLink('privacy-policy'),
        onClick: handleClickPrivacyPolicy,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "legal.privacyPolicyLink"
        })
      }, "gdprPolicy"),
      break: /*#__PURE__*/_jsx("br", {})
    }
  });
  if (isFlow(Flow.Integrations)) {
    const integrationName = getIntegrationName();
    return integrationName ? /*#__PURE__*/_jsx(CustomTermsAndConditions, {
      LegitimateInterest: LegitimateInterest,
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "legal.integrationsLegalText",
        options: {
          integrationName
        }
      })
    }) : /*#__PURE__*/_jsx(StyledPrivacyBanner, {
      className: "text-center",
      "data-test-id": "legitimate-interest",
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: LegitimateInterest
      })
    });
  }
  if (isIntent(Intent.walkthrough)) {
    return /*#__PURE__*/_jsx(CustomTermsAndConditions, {
      LegitimateInterest: LegitimateInterest,
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link: StyledUILink
        },
        message: "legal.guideCreatorLegalText_jsx"
      })
    });
  }
  return /*#__PURE__*/_jsx(StyledPrivacyBanner, {
    className: 'text-center',
    "data-test-id": "legitimate-interest",
    children: /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: LegitimateInterest
    })
  });
};
export default PrivacyBanner;